import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmbedConfigFilters  {
    _originalTypeClassName = "zERP.BO.EmbedConfigFilters";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmbedConfigFilters.translate = translateService;
}
this.expanded = false;
this.visible = false;
this.EmbedConfigFiltersKey = null;
this._key = this.EmbedConfigFiltersKey = 0; 
}

static translate: TranslateService;
_key: any;
expanded:any;
visible:any;
private _EmbedConfigFiltersKey:any;
get EmbedConfigFiltersKey(): any {
    return this._EmbedConfigFiltersKey;
  }
set EmbedConfigFiltersKey(value: any) {
    this._EmbedConfigFiltersKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmbedConfigFiltersKey == null || $this.EmbedConfigFiltersKey == 0;
            }


}